import { render } from "./AppHeader.vue?vue&type=template&id=6f1178b0&scoped=true"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=6f1178b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1178b0"]])

export default __exports__